import { axios } from 'lib';
import { donwloadFileFromURL } from 'features/frameworkAgreements/api/downloadFile';

export const getApplicationFile = async ({ applicationID, fileID }) => {
  const {
    data: { data },
  } = await axios.get(`/api/job_ads/applications/${applicationID}/files/${fileID}`);

  return data;
};

export const downloadApplicationFile = async ({ applicationID, fileID }) => {
  const data = await getApplicationFile({ applicationID, fileID });

  await donwloadFileFromURL(data.url, data.name);
};
